import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import Loader from '@/lib/components/Loader';

import styles from './../PaymentPage.module.scss';

const CartPaymentPlan = ({ summaryLoading, paymentRequestToken, schedulePlan, total }) => {
    const { t } = useTranslation();

    console.log('schedulePlan: ', schedulePlan);

    return <div className={styles.content_right_container}>
        <div className={styles.summary}>
            <div className={styles.summary_header}>{t('paymentPlanSummary')}</div>
            <div className={styles.summary_plan_container}>
                <div className={styles.summary_plan_content_header}>
                    <div className={styles.summary_date}>{t('date')}</div>
                    <div className={styles.summary_price}>{t('price')}</div>
                </div>
                <div className={styles.summary_plan_content}>
                    {schedulePlan?.map((plan, index) => (
                        <div className={styles.summary_plan_content_lines} key={index}>
                            <div className={styles.plan_date}>{plan?.due_date?.replaceAll('-', '/').split('T')[0]} {index == 0 && `(${t('today')})`}</div>
                            <div className={styles.plan_amount}>
                                {t('price.' + plan?.currency, {
                                    count: plan?.amount,
                                })}
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
        <div className={styles.normal_rate}>
            {summaryLoading ? (
                <Loader />
            ) : (
                <div className={styles.normal_rate_content}>
                    {schedulePlan.length > 0 &&
                        <div className={styles.rates}>
                            <div>{t('totalNow')}</div>
                            <div className={styles.price}>
                                {t('price.' + paymentRequestToken?.currency, {
                                    count: schedulePlan[0].amount,
                                })}
                            </div>
                        </div>
                    }
                    <div className={styles.rates}>
                        <div>{t('total')}</div>
                        <div className={styles.price}>
                            {t('price.' + paymentRequestToken?.currency, {
                                count: total,
                            })}
                        </div>
                    </div>
                    {/* Uncomment when fees management are implemented */}
                    {/* <div className={styles.rates}>
                        <div>Payment plan fee (Free)</div>
                        <div className={styles.price}>
                            {t('price.' + paymentRequestToken?.currency, {
                                count: '00.00',
                            })}
                        </div>
                    </div> */}
                </div>
            )}
        </div>
    </div>;
};

CartPaymentPlan.propTypes = {
    paymentRequestToken: PropTypes.object,
    summaryLoading: PropTypes.bool,
    schedulePlan: PropTypes.array,
};

export default CartPaymentPlan;
